import {
  addCurrentPageEventListener,
  objectToQueryString,
} from "../../shared/utils";
import { fetchWithPolling } from "@/lib/jsonRequest";

export function histogramChart(args) {
  const { chartName, endpoint, chartIndex } = args;
  let fetching = false;

  return {
    histogramData: null,
    showHistogram: false,
    histogramLoaded: false,
    rawSql: "",
    showQueryModal: false,
    init() {
      addCurrentPageEventListener("dx:datacloud-filters-changed", (e) => {
        if (this.showHistogram) {
          this.fetchAndDisplayHistogram(e.detail.filters);
        }
      });
    },
    formatHistogramData(data, sql) {
      if (Array.isArray(data)) {
        const dataToReturn = {
          chart: {
            data: data.map((item, index) => ({
              name: item?.label,
              value: item?.value,
              color: "#62C1F6", // Default color
              bucket: index,
            })),
          },
        };

        return dataToReturn;
      }

      // If data is in an unexpected format, return null
      return { data: null, sql: sql || "" };
    },
    fetchAndDisplayHistogram(filters, index) {
      if (chartIndex !== undefined && chartIndex !== index) return;

      this.histogramData = null;
      this.showHistogram = true;
      this.histogramLoaded = false;
      if (fetching) return;

      fetching = true;
      let finalEndpoint;

      if (endpoint && endpoint.endsWith("/histogram")) {
        finalEndpoint = `${endpoint}?${objectToQueryString(filters)}`;
      } else {
        finalEndpoint = `${endpoint}${
          chartName ? `/${chartName}` : ""
        }/histogram?${objectToQueryString(filters)}`;
      }

      fetchWithPolling(finalEndpoint, (resp) => !resp?.wait)
        .then((responseData) => {
          let formattedData;
          if (responseData?.histogram) {
            formattedData = this.formatHistogramData(responseData.histogram);
          } else {
            formattedData = responseData;
          }

          this.histogramData = formattedData;
          this.rawSql = formattedData?.sql;
          this.histogramLoaded = true;
        })
        .catch(() => {
          alert(
            "Your connection dropped. Please reload the page and try again.",
          );
        });
    },
    hideHistogram(index) {
      if (chartIndex !== undefined && chartIndex !== index) return;

      this.showHistogram = false;
      this.histogramLoaded = false;
    },
    maxOfSet() {
      if (this.histogramData?.chart?.data?.length > 0) {
        return Math.max(...this.histogramData.chart.data.map((d) => d.value));
      }
      return 1; // default value to avoid division by zero or NaN
    },
    showHistogramQueryModal() {
      this.showQueryModal = true;
    },
  };
}
